import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import { Autoplay } from 'swiper/modules';

import { Link } from "react-router-dom";


export default function SliderTopResult() {
    return (
        <>
            <Swiper
                slidesPerView={1}
                spaceBetween={10}

                autoplay={{
                    delay: 1500,
                    disableOnInteraction: false,
                }}
                breakpoints={{
                    '@0.00': {
                        slidesPerView: 1,
                        spaceBetween: 10,
                    },
                    '@0.75': {
                        slidesPerView: 2,
                        spaceBetween: 20,
                    },
                    '@1.00': {
                        slidesPerView: 3,
                        spaceBetween: 40,
                    },
                    '@1.50': {
                        slidesPerView: 3,
                        spaceBetween: 50,
                    },
                }}
                modules={[Autoplay]}
                className="mySwiper"
            >
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/118.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/118.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">Result</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/120.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/120.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">Result</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/121.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/121.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">Result</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/122.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/122.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">Result</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/123.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/123.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">Result</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/124.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/124.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">Result</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/125.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/125.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">Result</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/126.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/126.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">Result</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/127.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/127.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">Result</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/128.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/128.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">Result</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/129.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/129.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">Result</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/130.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/130.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">Result</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/1.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/1.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">Result</h5>
                        </div>
                    </div>
                </SwiperSlide>

                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/2.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/2.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">Result</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/3.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/3.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">Result</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/4.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/4.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">Result</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/5.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/5.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">Result</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/6.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/6.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">Result</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/7.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/7.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">Result</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/8.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/8.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">Result</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/9.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/9.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">Result</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/10.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/10.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">Result</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/11.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/11.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">Result</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/12.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/12.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">Result</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/13.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/13.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">Result</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/14.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/14.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">Result</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/15.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/15.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">Result</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/22.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/22.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">Result</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/18.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/18.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">Result</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/19.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/19.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">Result</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/20.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/20.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">Result</h5>
                        </div>
                    </div>
                </SwiperSlide>
                <SwiperSlide>
                    <div className="result_img m-2" data-aos="zoom-in" data-aos-duration={1000}>
                        <img src="assets/images/2025/21.webp" className="img-fluid" alt="Result" />
                        <div className="overlay" />
                        <div className="overlay-text">
                            <a href="assets/images/2025/21.webp" data-fancybox="gallery">
                                <i className="fa fa-plus fa-2x" />
                            </a>
                            <h5 className="fw-bold">Result</h5>
                        </div>
                    </div>
                </SwiperSlide>
            </Swiper>
        </>
    );
}
